import * as React from 'react'
import { NextSeo } from 'next-seo'

import { FACEBOOK_APP_ID, SITE_URL, SITE_TWITTER_HANDLE } from '@ulule/config'
import * as models from '@owl-nest/models'
import { t } from '@owl-nest/localize'
import * as hooks from '@owl-nest/hooks'
import * as utils from '@owl-nest/utils'

import { getCurrentLocale } from './router'

export function SEO({ project }: { project: models.project.Project }): React.ReactElement {
  const router = hooks.useNextRouter()
  const currentLocale = getCurrentLocale(router)

  const description = utils.text.stripTags(models.project.ownerDescription(project, currentLocale))
  const projectTitle = models.project.name(project, currentLocale)
  const pageTitle = Boolean(projectTitle) ? projectTitle : t('My page')
  const shareImage = models.project.shareImages(project, currentLocale)

  return (
    <NextSeo
      facebook={{
        appId: FACEBOOK_APP_ID,
      }}
      title={`${pageTitle} - Ulule`}
      description={description}
      additionalLinkTags={[
        {
          rel: 'icon',
          type: 'image/png',
          sizes: '48x48',
          href: SITE_URL + '/assets/img/common/favicon-48.png',
        },
        {
          rel: 'icon',
          type: 'image/png',
          sizes: '32x32',
          href: SITE_URL + '/assets/img/common/favicon-32.png',
        },
      ]}
      openGraph={{
        description,
        images: [
          {
            alt: pageTitle,
            url: shareImage ?? `${process.env.ASSET_PREFIX}/assets/img/common/default-share-image.jpg`,
          },
        ],
        siteName: 'Ulule',
        title: pageTitle,
        url: project.absolute_url,
      }}
      twitter={{
        site: SITE_TWITTER_HANDLE,
        cardType: 'summary_large_image',
      }}
    />
  )
}
